import styled, { createGlobalStyle } from 'styled-components';

import { focusRingOptOutDecl } from 'theme/mixins';

export const StyledField = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  height: 38px;
  padding: 0 ${({ theme }) => theme.spacing.sm}px;
  background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  .react-datepicker-wrapper {
    flex: 1;
    min-width: 0;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  background: none;
  border: none;
  outline: none;
  ${focusRingOptOutDecl}
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  cursor: pointer;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

export const StyledIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textMuted};
  pointer-events: none;
`;

export const DatePickerTheme = createGlobalStyle`
  .react-datepicker-popper { z-index: 1200; }

  .react-datepicker {
    font-family: ${({ theme }) => theme.fonts.regular};
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.m}px;
    color: ${({ theme }) => theme.colors.textPrimary};
    overflow: hidden;
  }

  .react-datepicker__header {
    background-color: ${({ theme }) => theme.colors.backgroundTertiary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding-top: 10px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header {
    color: ${({ theme }) => theme.colors.textPrimary};
    font-weight: 600;
  }

  .react-datepicker__day-name {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  .react-datepicker__day,
  .react-datepicker__time-name {
    color: ${({ theme }) => theme.colors.textSecondary};
    border-radius: ${({ theme }) => theme.borderRadius.s}px;
  }

  .react-datepicker__day:hover,
  .react-datepicker__time-list-item:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover} !important;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__time-list-item--selected {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.onPrimary} !important;
    font-weight: 600;
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.textMuted};
    opacity: 0.5;
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${({ theme }) => theme.colors.textMuted};
  }

  .react-datepicker__time-container,
  .react-datepicker__time,
  .react-datepicker__time-box {
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  }
  .react-datepicker__time-container {
    border-left: 1px solid ${({ theme }) => theme.colors.border};
  }
  .react-datepicker__time-list-item {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  .react-datepicker__triangle { display: none; }

  .react-datepicker {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .react-datepicker__children-container {
    order: 1;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.border};
    position: relative;
    z-index: 3;
  }
`;

export const StyledPopupActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;
